import { render, staticRenderFns } from "./scored.vue?vue&type=template&id=4949f6d1&scoped=true"
import script from "./scored.vue?vue&type=script&lang=js"
export * from "./scored.vue?vue&type=script&lang=js"
import style0 from "./scored.vue?vue&type=style&index=0&id=4949f6d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4949f6d1",
  null
  
)

export default component.exports